import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import AppLayout from '../layouts/AppLayout'
//import { setInstance } from '@/common/instance'
import store from '@/store';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { layout: AppLayout }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta: { layout: AppLayout }
  },
  {
    path: '/init',
    name: 'InitInstance',
    component: () => import('../views/instances/Init.vue')
  },  
  {
    path: '/init/clear',
    name: 'ClearInstance',
    component: () => import('../views/instances/Clear.vue')
  },  
  {
    path: '/sites',
    name: 'ListSites',
    component: () => import('../views/sites/SiteIndex.vue'),
  },
  {
    path: '/site/new',
    name: 'NewSite',
    component: () => import('../views/sites/SiteNew.vue')
  },
  {
    path: '/site/import/:site_id',
    name: 'ImportSite',
    component: () => import('../views/sites/SiteImport.vue')
  },
  {
    path: '/site/select_import',
    name: 'SelectImportSite',
    component: () => import('../views/sites/SiteSelectImport.vue')
  },
  {
    path: '/site/:id',
    name: 'ShowSite',
    component: () => import('../views/sites/SiteShow.vue')
  },
  {
    path: '/site/:id/edit',
    name: 'EditSite',
    component: () => import('../views/sites/SiteEdit.vue')
  },
  {
    path: '/site/:id/sync',
    name: 'SyncSite',
    component: () => import('../views/sites/SiteSync.vue')
  },
  {
    path: '/site/:id/map',
    name: 'SiteMap',
    component: () => import('../views/sites/SiteMap.vue')
  },  
  {
    path: '/images',
    name: 'ListImages',
    component: () => import('../views/images/ImageIndex.vue')
  },
  {
    path: '/image/:id',
    name: 'ShowImage',
    component: () => import('../views/images/ImageShow.vue')
  },
  {
    path: '/assets',
    name: 'ListAssets',
    component: () => import('../views/assets/Index.vue')
  },
  {
    path: '/asset/:id',
    name: 'ShowAsset',
    component: () => import('../views/assets/Show.vue')
  },
  {
    path: '/asset/:id/edit',
    name: 'EditAsset',
    component: () => import('../views/assets/Edit.vue')
  },
  {
    path: '/asset/new',
    name: 'NewAsset',
    component: () => import('../views/assets/New.vue')
  },
  {
    path: '/locations',
    name: 'ListLocations',
    component: () => import('../views/locations/Index.vue')
  },
  {
    path: '/location/:id',
    name: 'ShowLocation',
    component: () => import('../views/locations/Show.vue')
  },
  {
    path: '/location/:id/edit',
    name: 'EditLocation',
    component: () => import('../views/locations/Edit.vue')
  },
  {
    path: '/location/new',
    name: 'NewLocation',
    component: () => import('../views/locations/New.vue')
  },
  {
    path: '/meters',
    name: 'ListMeters',
    component: () => import('../views/meters/Index.vue')
  },
  {
    path: '/meters.json',
    name: 'ListMetersJson',
    component: () => import('../views/meters/JsonIndex.vue')
  },
  {
    path: '/meter/:id',
    name: 'ShowMeter',
    component: () => import('../views/meters/Show.vue')
  },
  {
    path: '/meter/:id/edit',
    name: 'EditMeter',
    component: () => import('../views/meters/Edit.vue')
  },
  {
    path: '/meter/new',
    name: 'NewMeter',
    component: () => import('../views/meters/New.vue')
  },
  {
    path: '/emos',
    name: 'ListEmos',
    component: () => import('../views/emos/Index.vue')
  },
  {
    path: '/emo/:id',
    name: 'ShowEmo',
    component: () => import('../views/emos/Show.vue')
  },
  {
    path: '/emo/:id/edit',
    name: 'EditEmo',
    component: () => import('../views/emos/Edit.vue')
  },
  {
    path: '/emo/new',
    name: 'NewEmo',
    component: () => import('../views/emos/New.vue')
  },
  {
    path: '/issues',
    name: 'ListIssues',
    component: () => import('../views/issues/Index.vue')
  },
  {
    path: '/issue/:id',
    name: 'ShowIssue',
    component: () => import('../views/issues/Show.vue')
  },
  {
    path: '/issue/:id/edit',
    name: 'EditIssue',
    component: () => import('../views/issues/Edit.vue')
  },
  {
    path: '/issue/new',
    name: 'NewIssue',
    component: () => import('../views/issues/New.vue')
  },
  {
    path: '/notes',
    name: 'ListNotes',
    component: () => import('../views/notes/Index.vue')
  },
  {
    path: '/clear_data',
    name: 'ClearData',
    component: () => import(/* webpackChunkName: "about" */ '../views/ClearData.vue')
  }
]

const checkHasInstance = function(to, from, next) {
  console.log("Inside router/index.js checkHasInstance, to ==> ", to);
  //const store = useStore();
  if (to.name == "InitInstance") {
    next();
  } else if (store.getters.currentInstance) {
    next();
  } else {
    next('/init');
  }
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach(checkHasInstance)

export default router
